export default __webpack_public_path__ + "static/media/clockicon.77ac9095.png";